<template>
	<edit :id="id" detail="1"></edit>
</template>

<script>
	import edit from './product_edit.vue'
	
	export default {
		name: 'product_detail',
		
		props: {
            id: String
		},
		
		components: {
			edit
		}
	}
</script>